import React, { useState } from 'react'
import './FeedbackSystem.css'

interface FeedbackSystemProps {
  predictionId?: number
  predictedGender: string
  confidence: number
  onFeedbackSubmit: (actualGender: string, isNotBabyScan?: boolean) => void
  isVisible: boolean
}

const FeedbackSystem: React.FC<FeedbackSystemProps> = ({
  predictedGender,
  confidence,
  onFeedbackSubmit,
  isVisible
}) => {
  const [selectedGender, setSelectedGender] = useState<string>('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)

  if (!isVisible) return null

  const handleSubmit = async () => {
    if (!selectedGender) return

    setIsSubmitting(true)
    try {
      const isNotBabyScan = selectedGender === 'NotBaby'
      const actualGender = isNotBabyScan ? '' : selectedGender
      await onFeedbackSubmit(actualGender, isNotBabyScan)
      setIsSubmitted(true)
      setTimeout(() => {
        setIsSubmitted(false)
        setSelectedGender('')
      }, 3000)
    } catch (error) {
      console.error('Error submitting feedback:', error)
    } finally {
      setIsSubmitting(false)
    }
  }

  if (isSubmitted) {
    return (
      <div className="feedback-system">
        <div className="feedback-success">
          <span className="success-icon">✅</span>
          <h3>Thank you for your feedback!</h3>
          <p>This helps our AI learn and improve predictions for everyone.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="feedback-system">
      <div className="feedback-header">
        <h3>Help us learn!</h3>
        <p>Do you know the actual gender? Your feedback helps improve our AI.</p>
      </div>

      <div className="prediction-summary">
        <div className="prediction-info">
          <span className="prediction-label">Our Prediction:</span>
          <span className={`prediction-value ${predictedGender.toLowerCase()}`}>
            {predictedGender}
          </span>
          <span className="confidence-badge">
            {confidence}% confidence
          </span>
        </div>
      </div>

      <div className="feedback-form">
        <p className="form-label">What is the actual gender?</p>
        <div className="gender-options">
          <button
            className={`gender-option boy ${selectedGender === 'Boy' ? 'selected' : ''}`}
            onClick={() => setSelectedGender('Boy')}
          >
            <span className="gender-icon">👶</span>
            <span>Boy</span>
          </button>
          <button
            className={`gender-option girl ${selectedGender === 'Girl' ? 'selected' : ''}`}
            onClick={() => setSelectedGender('Girl')}
          >
            <span className="gender-icon">👶</span>
            <span>Girl</span>
          </button>
          <button
            className={`gender-option unknown ${selectedGender === 'Unknown' ? 'selected' : ''}`}
            onClick={() => setSelectedGender('Unknown')}
          >
            <span className="gender-icon">❓</span>
            <span>Don't Know</span>
          </button>
          <button
            className={`gender-option not-baby ${selectedGender === 'NotBaby' ? 'selected' : ''}`}
            onClick={() => setSelectedGender('NotBaby')}
          >
            <span className="gender-icon">🚫</span>
            <span>Not a Baby Scan</span>
          </button>
        </div>

        <button
          className="submit-feedback"
          onClick={handleSubmit}
          disabled={!selectedGender || isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Submit Feedback'}
        </button>

        <p className="privacy-note">
          Your feedback is anonymous and used only to improve prediction accuracy.
        </p>
      </div>
    </div>
  )
}

export default FeedbackSystem